/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { __core_private__ as r } from '@angular/core';
export var /** @type {?} */ isDefaultChangeDetectionStrategy = r.isDefaultChangeDetectionStrategy;
export var /** @type {?} */ ChangeDetectorStatus = r.ChangeDetectorStatus;
export var /** @type {?} */ LifecycleHooks = r.LifecycleHooks;
export var /** @type {?} */ LIFECYCLE_HOOKS_VALUES = r.LIFECYCLE_HOOKS_VALUES;
export var /** @type {?} */ ReflectorReader = r.ReflectorReader;
export var /** @type {?} */ ViewContainer = r.ViewContainer;
export var /** @type {?} */ CodegenComponentFactoryResolver = r.CodegenComponentFactoryResolver;
export var /** @type {?} */ ComponentRef_ = r.ComponentRef_;
export var /** @type {?} */ AppView = r.AppView;
export var /** @type {?} */ DebugAppView = r.DebugAppView;
export var /** @type {?} */ NgModuleInjector = r.NgModuleInjector;
export var /** @type {?} */ registerModuleFactory = r.registerModuleFactory;
export var /** @type {?} */ ViewType = r.ViewType;
export var /** @type {?} */ view_utils = r.view_utils;
export var /** @type {?} */ DebugContext = r.DebugContext;
export var /** @type {?} */ StaticNodeDebugInfo = r.StaticNodeDebugInfo;
export var /** @type {?} */ devModeEqual = r.devModeEqual;
export var /** @type {?} */ UNINITIALIZED = r.UNINITIALIZED;
export var /** @type {?} */ ValueUnwrapper = r.ValueUnwrapper;
export var /** @type {?} */ TemplateRef_ = r.TemplateRef_;
export var /** @type {?} */ RenderDebugInfo = r.RenderDebugInfo;
export var /** @type {?} */ Console = r.Console;
export var /** @type {?} */ reflector = r.reflector;
export var /** @type {?} */ Reflector = r.Reflector;
export var /** @type {?} */ ReflectionCapabilities = r.ReflectionCapabilities;
export var /** @type {?} */ NoOpAnimationPlayer = r.NoOpAnimationPlayer;
export var /** @type {?} */ AnimationPlayer = r.AnimationPlayer;
export var /** @type {?} */ AnimationSequencePlayer = r.AnimationSequencePlayer;
export var /** @type {?} */ AnimationGroupPlayer = r.AnimationGroupPlayer;
export var /** @type {?} */ AnimationKeyframe = r.AnimationKeyframe;
export var /** @type {?} */ AnimationStyles = r.AnimationStyles;
export var /** @type {?} */ ANY_STATE = r.ANY_STATE;
export var /** @type {?} */ DEFAULT_STATE = r.DEFAULT_STATE;
export var /** @type {?} */ EMPTY_STATE = r.EMPTY_STATE;
export var /** @type {?} */ FILL_STYLE_FLAG = r.FILL_STYLE_FLAG;
export var /** @type {?} */ prepareFinalAnimationStyles = r.prepareFinalAnimationStyles;
export var /** @type {?} */ balanceAnimationKeyframes = r.balanceAnimationKeyframes;
export var /** @type {?} */ clearStyles = r.clearStyles;
export var /** @type {?} */ collectAndResolveStyles = r.collectAndResolveStyles;
export var /** @type {?} */ renderStyles = r.renderStyles;
export var /** @type {?} */ ViewMetadata = r.ViewMetadata;
export var /** @type {?} */ ComponentStillLoadingError = r.ComponentStillLoadingError;
export var /** @type {?} */ AnimationTransition = r.AnimationTransition;
//# sourceMappingURL=private_import_core.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/compiler/src/private_import_core.js
// module id = 12
// module chunks = 4